import { RefinementListProvided } from 'react-instantsearch-core'
import { connectRefinementList } from 'react-instantsearch-dom'

import Checkbox from 'components/Filters/Checkbox'
import CheckboxList from 'components/Filters/CheckboxList'
import Hit from 'components/Filters/types/Hit'
import LocalizedRefinementItem from 'components/Filters/types/LocalizedRefinementItem'
import useLocalisedRefinementItems from 'components/Filters/useLocalisedRefinementItems'
import FilterWrapper from 'components/UI/Filters/FilterWrapper'

const ITEMS: LocalizedRefinementItem[] = [
  {
    key: 'video-request-express-delivery',
    label: (t) => t(`addonsFilter.expressDelivery`, '24 Hours delivery'),
  },
]

const onlyEnabledAddons = ({ label }: Hit): boolean =>
  ITEMS.some((addon) => addon.key === label)

const CustomAddonsRefinementList = ({
  items,
  refine,
}: RefinementListProvided) => {
  const { toLocalisedLabel } = useLocalisedRefinementItems(ITEMS)

  const addons = items.filter(onlyEnabledAddons)

  if (!addons.length) {
    return null
  }

  return (
    <FilterWrapper>
      <CheckboxList>
        {addons.map(toLocalisedLabel).map((item) => (
          <Checkbox key={item.label} item={item} refine={refine} />
        ))}
      </CheckboxList>
    </FilterWrapper>
  )
}

export default connectRefinementList(CustomAddonsRefinementList)
